import { IExtendedEvent, IRequestConfig } from '../types';

type TRequestProps = Required<Pick<IRequestConfig, 'agreementNumber'>> & {
    events: IExtendedEvent[],
}

export const postEvents = async({ agreementNumber, events }: TRequestProps): Promise<void> => {
    const baseUrl = process.env.NEXT_PUBLIC_HOST_API_CAMPAIGN;

    await fetch(`${baseUrl}/api/v1/analytics/events`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'agreementNumber': `${agreementNumber}`,
        },
        body: JSON.stringify({ events }),
    });
};
